/* @jsx h */
import { defineComponent, h, ref } from "vue";
import { Order, FoodType } from "@lemmonhq/types";
import { OrderCardMain } from "../../../components/Orders/OrderCard/OrderCardMain";

export interface PaymentOrdersComponentProps {
  orders: Order[];
  foodTypes: FoodType[];
}

export const PaymentOrdersComponent =
  defineComponent<PaymentOrdersComponentProps>({
    name: "PaymentOrdersComponent",
    props: ["orders", "foodTypes"],
    setup(props) {
      const ordersRef = ref(props.orders);

      // No-op handlers since this is read-only view
      const handleFoodStatusChange = async (
        orderId: number,
        foodTypeId: number,
        currentStatus: string,
      ) => {
        // No-op in payment view
      };

      const handleOrderCancel = (orderId: number) => {
        // No-op in payment view
      };

      const handleCloseOpenOrder = async (order: Order): Promise<boolean> => {
        // No-op in payment view
        return false;
      };

      const handleOrderUpdate = (order: Order) => {
        // No-op in payment view
      };

      return () => (
        <div class="flex-1 overflow-y-auto p-4 space-y-4">
          {props.orders.length === 0 ? (
            <div class="text-center py-8">
              No orders found for this payment.
            </div>
          ) : (
            props.orders.map((order) => (
              <div key={order.id} class="  ">
                <OrderCardMain
                  order={order}
                  orders={ordersRef}
                  onFoodStatusChange={handleFoodStatusChange}
                  onOrderCancel={handleOrderCancel}
                  closeOpenOrder={handleCloseOpenOrder}
                  foodTypes={props.foodTypes}
                  onOrderUpdate={handleOrderUpdate}
                />
              </div>
            ))
          )}
        </div>
      );
    },
  });
